import { Col, Container, Row, Button } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';

// components
import { FormInput } from '../form';
import SwiperSlider5 from '../sliders/SwiperSlider5';
import { Link } from 'react-router-dom';
import Swiper, { Autoplay } from 'swiper';
import { SwiperSlide } from 'swiper/react';
import { colors } from 'styles/colors';





const Hero12 = () => {
    return (
        <>
            <section className="relative overflow-hidden" style={{ backgroundColor: "#24347D" }}>
                <div className="absolute inset-0 bg-gradient-to-br from-[#24347D] via-[#26458D] to-[#26A2AB]"></div>

                <div className="absolute inset-0 opacity-10">
                    <svg className="h-full w-full" viewBox="0 0 1200 600" preserveAspectRatio="none">
                        <path d="M0,420 C200,360 280,520 520,460 C760,400 820,520 1200,430 L1200,600 L0,600 Z" fill="white" />
                    </svg>
                </div>

                <div className="absolute left-0 top-0 h-96 w-96 animate-pulse rounded-full bg-[#26A2AB]/20 blur-3xl"></div>
                <div className="absolute bottom-0 right-0 h-96 w-96 animate-pulse rounded-full bg-[#24347D]/40 blur-3xl"></div>

                <div className="relative mx-auto w-full max-w-7xl px-4 sm:px-6 md:px-8 lg:px-8 py-12">
                    {/* <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16"> */}


                    {/* Left Content */}
                    {/* <div className="text-white mt-20 md:mt-10 lg:mt-0"> */}
                    <div className="grid items-center gap-8 sm:gap-10 lg:grid-cols-2 lg:gap-16">

                        <div className="text-white mt-16 md:mt-12 lg:mt-0 text-center sm:text-left">

                            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4  py-2 backdrop-blur-sm">
                                <span className="h-2 w-2 rounded-full bg-[#26A2AB]"></span>
                                <span className="text-sm font-medium tracking-wide">AI-powered CRM for small & growing businesses</span>
                            </div>



                            {/* Headline */}
                            <h1 className="mt-3  font-bold leading-tight text-white tracking-tight text-3xl sm:text-4xl md:text-5xl lg:text-6xl">
                                Track Sales. Boost Revenue.
                                <span className="mt-2 block bg-gradient-to-r from-[#26A2AB] to-[#9194a0] bg-clip-text text-transparent">
                                    Automate follow-ups with AI
                                </span>
                            </h1>

                            {/* Description */}
                            {/* <p className="mt-4 max-w-xl text-lg text-white/80"> */}
                            <p className="mt-4 max-w-xl text-base md:text-lg text-white/80 mx-auto lg:mx-0">
                                SalesTrackify helps you manage leads, close deals, and automate workflows with AI—so your team spends less
                                time on admin and more time winning.
                            </p>



                            <div className="mt-4 sm:mt-8   justify-center lg:justify-start gap-3 sm:gap-4">
                                <div className="overflow-hidden rounded-xl bg-white p-1 shadow-xl inline-block">
                                    <Link
                                        to="/contact"
                                        className="inline-flex items-center justify-center px-6 py-3 sm:px-8 sm:py-4 text-sm sm:text-base font-semibold transition-all hover:scale-105 shadow-lg whitespace-nowrap"
                                        style={{
                                            backgroundColor: "#26A2AB",
                                            color: "white",
                                            borderRadius: "0.75rem"
                                        }}
                                    >
                                        Book a Demo
                                    </Link>
                                </div>
                            </div>

                            {/* <div className="mt-4 grid max-w-xl grid-cols-3 gap-4">
                                {[
                                    { value: "Smart", label: "Lead Management" },
                                    { value: "Real-time", label: "Sales Tracking" },
                                    { value: "Powerful", label: "Analytics & Reports" }
                                ].map((stat, idx) => (
                                    <div key={idx} className="rounded-2xl bg-white/5 p-4 backdrop-blur-sm">
                                        <p className="text-xl font-bold text-white">{stat.value}</p>
                                        <p className="text-xs text-white/60">{stat.label}</p>
                                    </div>
                                ))}
                            </div> */}

                            <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4 max-w-xl mx-auto lg:mx-0">
                                {[
                                    { value: "Smart", label: "Lead Management" },
                                    { value: "Real-time", label: "Sales Tracking" },
                                    { value: "Powerful", label: "Analytics & Reports" }
                                ].map((stat, idx) => (
                                    <div
                                        key={idx}
                                        className="rounded-2xl bg-white/5 p-3 sm:p-4 backdrop-blur-sm flex flex-col items-center justify-center text-center"
                                    >
                                        <p className="text-sm sm:text-lg md:text-xl font-bold text-white">
                                            {stat.value}
                                        </p>
                                        <p className="text-[10px] sm:text-xs md:text-sm text-white/60">
                                            {stat.label}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Right Content - Dashboard Card */}
                        <div className="relative  ">
                            {/* Main Card */}
                            {/* <div className="rounded-3xl bg-white/95 p-3 sm:p-4 shadow-2xl w-full max-w-lg mx-auto backdrop-blur-sm"> */}
                            <div className="rounded-3xl bg-white/95 p-3 sm:p-4 shadow-2xl w-full max-w-md lg:max-w-lg mx-auto backdrop-blur-sm">

                                {/* <div className="rounded-3xl bg-white/95 p-3 sm:p-4 shadow-2xl w-full max-w-sm sm:max-w-md lg:max-w-lg mx-auto backdrop-blur-sm"></div> */}
                                {/* Card Header */}
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-2">
                                        <div className="h-3 w-3 rounded-full" style={{ backgroundColor: "#26A2AB" }}></div>
                                        <div className="h-3 w-3 rounded-full bg-yellow-500"></div>
                                        <div className="h-3 w-3 rounded-full bg-red-500"></div>
                                        <span className="ml-2 text-sm font-medium text-slate-600">Dashboard</span>
                                    </div>
                                    <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-slate-600">This week</span>
                                </div>

                                {/* KPI Grid */}
                                <div className="mt-3 grid grid-cols-3 gap-3">
                                    {[
                                        { label: "Pipeline", value: "$87,230" },
                                        { label: "New Leads", value: "52" },
                                        { label: "Conversion", value: "21.5%" }
                                    ].map((kpi, idx) => (
                                        // <div key={idx} className="rounded-xl  bg-slate-50 p-3">
                                        <div key={idx} className="rounded-xl bg-slate-50 p-2 sm:p-3 flex flex-col items-center justify-center text-center">
                                            {/* <p className="text-xs text-sm sm:text-lg md:text-xl text-slate-500">{kpi.label}</p> */}
                                            <p className="text-[10px] sm:text-xs md:text-sm text-slate-500">{kpi.label}</p>
                                            {/* <p className="mt-1 text-sm sm:text-lg md:text-xl text-lg font-bold text-slate-900">{kpi.value}</p> */}
                                            <p className="mt-1 text-sm sm:text-base md:text-lg font-bold text-slate-900">{kpi.value}</p>
                                        </div>
                                    ))}
                                </div>



                                {/* Sales Growth Chart */}
                                <div className="mt-3 rounded-xl bg-slate-50 p-5">

                                    <div className="mt-0 rounded-xl bg-slate-50 p-0">
                                        <div className="flex items-center justify-between mb-3">
                                            <p className="text-sm font-semibold text-slate-800">Sales Growth</p>
                                            <span className="flex items-center gap-1 text-xs font-semibold" style={{ color: "#26A2AB" }}>
                                                <span>↑</span> Trending
                                            </span>
                                        </div>

                                        {/* Fixed Chart Container */}
                                        {/* <div className="flex h-40 items-end justify-between gap-1"> */}
                                        <div className="flex h-32 sm:h-36 md:h-40 items-end justify-between gap-1">
                                            {/* Bar 1 - 30% */}
                                            <div className="relative flex h-full w-5 sm:w-6 md:w-7 lg:w-8 flex-col justify-end group">
                                                <div className="absolute -top-6 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-xs rounded px-1.5 py-0.5">
                                                    30%
                                                </div>
                                                <div className="w-full bg-gradient-to-t from-[#26A2AB] to-[#24347D] rounded-t-lg" style={{ height: '30%' }}></div>
                                            </div>

                                            {/* Bar 2 - 45% */}
                                            <div className="relative flex h-full w-5 sm:w-6 md:w-7 lg:w-8 flex-col justify-end group">
                                                <div className="absolute -top-6 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-xs rounded px-1.5 py-0.5">
                                                    45%
                                                </div>
                                                <div className="w-full bg-gradient-to-t from-[#26A2AB] to-[#24347D] rounded-t-lg" style={{ height: '45%' }}></div>
                                            </div>

                                            {/* Bar 3 - 50% */}
                                            <div className="relative flex h-full w-5 sm:w-6 md:w-7 lg:w-8 flex-col justify-end group">
                                                <div className="absolute -top-6 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-xs rounded px-1.5 py-0.5">
                                                    50%
                                                </div>
                                                <div className="w-full bg-gradient-to-t from-[#26A2AB] to-[#24347D] rounded-t-lg" style={{ height: '50%' }}></div>
                                            </div>

                                            {/* Bar 4 - 65% */}
                                            <div className="relative flex h-full w-5 sm:w-6 md:w-7 lg:w-8 flex-col justify-end group">
                                                <div className="absolute -top-6 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-xs rounded px-1.5 py-0.5">
                                                    65%
                                                </div>
                                                <div className="w-full bg-gradient-to-t from-[#26A2AB] to-[#24347D] rounded-t-lg" style={{ height: '65%' }}></div>
                                            </div>

                                            {/* Bar 5 - 75% */}
                                            <div className="relative flex h-full w-5 sm:w-6 md:w-7 lg:w-8 flex-col justify-end group">
                                                <div className="absolute -top-6 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-xs rounded px-1.5 py-0.5">
                                                    75%
                                                </div>
                                                <div className="w-full bg-gradient-to-t from-[#26A2AB] to-[#24347D] rounded-t-lg" style={{ height: '75%' }}></div>
                                            </div>

                                            {/* Bar 6 - 85% */}
                                            <div className="relative flex h-full w-5 sm:w-6 md:w-7 lg:w-8 flex-col justify-end group">
                                                <div className="absolute -top-6 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-xs rounded px-1.5 py-0.5">
                                                    85%
                                                </div>
                                                <div className="w-full bg-gradient-to-t from-[#26A2AB] to-[#24347D] rounded-t-lg" style={{ height: '85%' }}></div>
                                            </div>

                                            {/* Bar 7 - 95% (Highlighted) */}
                                            <div className="relative flex h-full w-5 sm:w-6 md:w-7 lg:w-8 flex-col justify-end group">
                                                <div className="absolute -top-6 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-xs rounded px-1.5 py-0.5">
                                                    95%
                                                </div>
                                                <div className="w-full bg-gradient-to-t from-[#26A2AB] to-[#24347D] rounded-t-lg" style={{ height: '95%' }}></div>
                                            </div>
                                        </div>

                                        {/* X-axis labels (optional) */}
                                        {/* <div className="flex justify-between gap-1 mt-2"> */}
                                        <div className="flex justify-between gap-1 mt-2 text-[10px] sm:text-xs">
                                            {/* <div className="w-8 text-center"> */}
                                            <div className="flex-1 text-center">
                                                <span className="text-xs text-slate-500">Mon</span>
                                            </div>
                                            {/* <div className="w-8 text-center"> */}
                                            <div className="flex-1 text-center">
                                                <span className="text-xs text-slate-500">Tue</span>
                                            </div>
                                            {/* <div className="w-8 text-center"> */}
                                            <div className="flex-1 text-center">
                                                <span className="text-xs text-slate-500">Wed</span>
                                            </div>
                                            {/* <div className="w-8 text-center"> */}
                                            <div className="flex-1 text-center">
                                                <span className="text-xs text-slate-500">Thu</span>
                                            </div>
                                            {/* <div className="w-8 text-center"> */}
                                            <div className="flex-1 text-center">
                                                <span className="text-xs text-slate-500">Fri</span>
                                            </div>
                                            {/* <div className="w-8 text-center"> */}
                                            <div className="flex-1 text-center">
                                                <span className="text-xs text-slate-500">Sat</span>
                                            </div>
                                            {/* <div className="w-8 text-center"> */}
                                            <div className="flex-1 text-center">
                                                <span className="text-xs text-slate-500">Sun</span>
                                            </div>
                                        </div>
                                    </div>



                                </div>

                                {/* Bottom Grid */}
                                {/* <div className="mt-3 grid gap-4 sm:grid-cols-2">
                         
                                    <div className="rounded-xl bg-slate-50 p-3">
                                        <p style={{ color: colors.primary.teal }} className="text-sm font-semibold text-slate-800">Top Deals</p>
                                        <div className="mt-2 space-y-3">
                                            {[
                                                { name: "Acme Inc.", value: "$8,300" },
                                                { name: "Delta Corp", value: "$4,200" },
                                                { name: "Stark Solutions", value: "$3,900" }
                                            ].map((deal, idx) => (
                                                <div key={idx} className="flex items-center justify-between">
                                                    <span className="text-sm text-slate-600">{deal.name}</span>
                                                    <span className="text-sm font-semibold text-slate-900">{deal.value}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                    
                                    <div className="rounded-xl bg-slate-50 p-3">
                                        <p style={{ color: colors.primary.teal }} className="text-sm font-semibold text-slate-800">Upcoming Tasks</p>
                                        <div className="mt-2 space-y-3">
                                            {[
                                                { task: "Follow-up email", tag: "Today", color: "text-[#26A2AB] bg-[#26A2AB]/10" },
                                                { task: "Demo call", tag: "Tomorrow", color: "text-[#24347D] bg-[#24347D]/10" },
                                                { task: "Send quote", tag: "This week", color: "text-slate-600 bg-slate-100" }
                                            ].map((item, idx) => (
                                                <div key={idx} className="flex items-center justify-between">
                                                    <span className="text-sm text-slate-600">{item.task}</span>
                                                    <span className={`rounded-full px-2 py-0 text-xs font-medium`}
                                                        style={item.color.includes('bg-') ? {} : {
                                                            color: item.tag === 'Today' ? '#26A2AB' : '#24347D',
                                                            backgroundColor: item.tag === 'Today' ? '#26A2AB10' : '#24347D10'
                                                        }}>
                                                        {item.tag}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </>

    );
};

export default Hero12;





